/**
 * Base64 encoding utilities for handling UTF-8 content
 * Replaces deprecated btoa/unescape pattern with modern approach
 */

/**
 * Converts a UTF-8 string to Base64
 * Handles multi-byte characters correctly (unlike btoa which only supports Latin1)
 * @param str - UTF-8 string to encode
 * @returns Base64 encoded string
 */
export function utf8ToBase64(str: string): string {
  try {
    // Use TextEncoder for proper UTF-8 encoding
    const encoder = new TextEncoder();
    const uint8Array = encoder.encode(str);
    
    // Convert Uint8Array to binary string
    let binary = '';
    uint8Array.forEach(byte => {
      binary += String.fromCharCode(byte);
    });
    
    // Use btoa on the binary string (which is now Latin1-safe)
    return btoa(binary);
  } catch (error) {
    console.error('[utf8ToBase64] Encoding failed:', error);
    throw new Error('Failed to encode string to Base64');
  }
}

/**
 * Converts an ArrayBuffer to Base64
 * @param buffer - ArrayBuffer to encode
 * @returns Base64 encoded string
 */
export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  bytes.forEach(b => binary += String.fromCharCode(b));
  return btoa(binary);
}
